/*ساخت و ساز*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={86.825}
      height={99.688}
      viewBox="0 0 86.825 99.688"
      {...props}
    >
      <path
        data-name="Path 7630"
        d="M57.947 70.843l-14.53 15.982-14.54-15.982 4.1-1.672a6.722 6.722 0 001.608-.949 9.657 9.657 0 0017.654 0 6.722 6.722 0 001.608.949z"
        fill="#ccd1d9"
      />
      <g data-name="Group 361" fill="#b27946">
        <path
          data-name="Path 7631"
          d="M59.492 71.47v16.963H43.413v-1.608l14.535-15.982z"
        />
        <path
          data-name="Path 7632"
          d="M28.878 70.843l14.535 15.982v1.608H27.334V71.47z"
        />
        <path
          data-name="Path 7633"
          d="M17.687 88.433v9.647H1.608a23.957 23.957 0 0114.889-22.173l1.19-.482z"
        />
        <path
          data-name="Path 7634"
          d="M85.218 98.08H69.139V75.425l1.19.482A23.979 23.979 0 0185.218 98.08z"
        />
      </g>
      <path
        data-name="Path 7635"
        d="M69.139 88.433v9.647H17.687v-9.647h51.452z"
        fill="#ff826e"
      />
      <path
        data-name="Path 7636"
        d="M69.138 75.425v13.008h-9.647V71.47z"
        fill="#fc6e51"
      />
      <path
        data-name="Path 7637"
        d="M27.334 71.47v16.963h-9.647V75.425z"
        fill="#fc6e51"
      />
      <path
        data-name="Path 7638"
        d="M57.884 20.906H18.491A25.765 25.765 0 0137.11 2.396v.016l2.283 8.94a4.15 4.15 0 008.039 0l2.283-8.94v-.016a25.707 25.707 0 0118.62 18.51z"
        fill="#fcd770"
      />
      <path
        data-name="Path 7639"
        d="M49.716 2.396v.012l-2.286 8.944a4.15 4.15 0 01-8.039 0L37.11 2.408v-.012a25.605 25.605 0 0112.606 0z"
        fill="#ffc729"
      />
      <path
        data-name="Path 7640"
        d="M72.354 22.51v3.216a1.613 1.613 0 01-1.608 1.608H16.079a1.613 1.613 0 01-1.608-1.608V22.51a1.613 1.613 0 011.608-1.608h54.668a1.613 1.613 0 011.607 1.608z"
        fill="#ffc729"
      />
      <path
        data-name="Path 7641"
        d="M24.118 33.765a6.43 6.43 0 00-6.431 6.432V27.334h6.431z"
        fill="#656d78"
      />
      <path
        data-name="Path 7642"
        d="M69.138 27.334v12.863a6.423 6.423 0 00-6.431-6.432v-6.431z"
        fill="#656d78"
      />
      <path
        data-name="Path 7643"
        d="M67.258 35.646a6.435 6.435 0 01-4.55 10.982h-1.512a28.113 28.113 0 001.511-9.084v-3.779a6.472 6.472 0 014.551 1.881z"
        fill="#f0d0b4"
      />
      <path
        data-name="Path 7644"
        d="M49.844 63.206a6.44 6.44 0 002.4 5.017 9.657 9.657 0 01-17.654 0 6.44 6.44 0 002.4-5.017v-1.994a28.3 28.3 0 006.431 3.1 28.294 28.294 0 006.431-3.1z"
        fill="#f0d0b4"
      />
      <path
        data-name="Path 7645"
        d="M62.707 33.765v3.779a28.262 28.262 0 01-19.295 26.771 28.268 28.268 0 01-19.294-26.771v-10.21h38.589z"
        fill="#f0d0b4"
      />
      <path
        data-name="Path 7646"
        d="M25.63 46.628h-1.512a6.431 6.431 0 010-12.863v3.778a28.113 28.113 0 001.512 9.085z"
        fill="#f0d0b4"
      />
      <circle
        data-name="Ellipse 361"
        cx={1.619}
        cy={1.619}
        r={1.619}
        transform="translate(51.831 34.009)"
      />
      <circle
        data-name="Ellipse 362"
        cx={1.619}
        cy={1.619}
        r={1.619}
        transform="translate(32.397 34.009)"
      />
      <path
        data-name="Path 7647"
        d="M49.844 49.844h-3.216a3.216 3.216 0 01-6.431 0h-3.216a6.431 6.431 0 1012.863 0z"
      />
      <path
        data-name="Path 7648"
        d="M70.944 74.425l-16.5-6.748a4.807 4.807 0 01-3-4.465v-1.155A29.762 29.762 0 0062.32 48.236h.387a8.048 8.048 0 008.039-8.036V28.942a3.219 3.219 0 003.216-3.216V22.51a3.219 3.219 0 00-3.216-3.216H69.52a27.31 27.31 0 00-52.214 0h-1.227a3.219 3.219 0 00-3.216 3.216v3.216a3.219 3.219 0 003.216 3.216V40.2a8.048 8.048 0 008.039 8.039h.387a29.754 29.754 0 0010.868 13.818v1.154a4.8 4.8 0 01-3 4.463l-16.5 6.748A25.471 25.471 0 000 98.08v1.608h86.825V98.08a25.468 25.468 0 00-15.881-23.655zM19.294 76.5l6.431-2.63v12.955h-6.431zm9.648-3.2l12.3 13.527h-12.3zm16.643 13.525L57.883 73.3v13.525zM61.1 73.872l6.432 2.63v10.323H61.1zm2.274-28.919a29.862 29.862 0 00.942-7.407v-1.877a4.8 4.8 0 01-.942 9.284zm4.158-11.146a7.962 7.962 0 00-3.216-1.486v-3.38h3.216zM47.743 3.615l-1.876 7.342a2.532 2.532 0 01-4.907 0l-1.877-7.341a23.662 23.662 0 018.66 0zm-11.778.791l1.878 7.348a5.749 5.749 0 0011.139 0l1.878-7.348a24.082 24.082 0 0115.3 14.889h-6.669v-3.216h-3.215v3.216H53.06v-3.216h-3.216v3.216H36.981v-3.216h-3.216v3.216H30.55v-3.216h-3.216v3.216h-6.666A24.082 24.082 0 0135.965 4.406zM16.079 22.51h54.667v3.216H16.079zm6.431 6.431v3.379a7.983 7.983 0 00-3.216 1.486v-4.864zM19.294 40.2a4.817 4.817 0 013.216-4.528v1.876a29.863 29.863 0 00.942 7.407 4.816 4.816 0 01-4.158-4.755zm6.431-2.651v-8.6H61.1v8.6a26.571 26.571 0 01-17.687 25.065 26.57 26.57 0 01-17.687-25.069zM42.9 65.839l.508.17.508-.169a30.051 30.051 0 004.372-1.852 7.992 7.992 0 001.957 4.547 8.03 8.03 0 01-13.675 0 7.982 7.982 0 001.957-4.547 29.893 29.893 0 004.373 1.851zm-9.31 4.814c.138-.056.262-.133.4-.2a11.236 11.236 0 0018.844 0c.133.064.259.141.4.2l1.974.809-11.795 12.974-11.794-12.974zM3.272 96.472a22.235 22.235 0 0112.807-18.611v18.611zm16.022 0v-6.431h48.237v6.431zm51.452 0V77.861a22.235 22.235 0 0112.807 18.611z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
